import { Mail } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { FaqList } from "@/components/site/FaqList";
import { LeadCapture } from "@/components/site/LeadCapture";
import { useSeo } from "@/lib/useSeo";
import { faqSchema } from "@/lib/schema";
import { FAQS } from "@/lib/content";

const SUPPORT_DESC = "Answers to common questions, our 7-day refund policy and how to contact First Mover OS.";

const CONTACT_EMAIL = "[your-support-email]";

const POLICIES = [
  { id: "refund", title: "Refund policy", body: "You can request a full refund within 7 days of purchase. Email us with your order number and we will refund the full amount to your original payment method. No questions asked." },
  { id: "privacy", title: "Privacy", body: "We collect only the data needed to process your order and, if you subscribe, to send you emails. Payments are processed securely by Shopify and its payment partners. You can unsubscribe at any time. [Replace with your full privacy policy.]" },
  { id: "terms", title: "Terms", body: "Digital products are licensed for personal use. Sharing or reselling the files is not permitted. Results depend on your own effort and are not guaranteed. [Replace with your full terms of service.]" },
];

export default function Support() {
  useSeo("FAQ, Policies & Contact", SUPPORT_DESC, faqSchema(FAQS, "FAQ, Policies & Contact", "/support", SUPPORT_DESC));
  return (
    <main data-testid="support-page" className="pt-28 md:pt-36">
      <section className="mx-auto max-w-7xl px-6 md:px-12">
        <p className="eyebrow">Support</p>
        <h1 className="font-display mt-5 text-5xl font-medium tracking-tight text-white md:text-7xl">FAQ, policies <span className="font-serif-i text-zinc-400">&amp; contact.</span></h1>
      </section>
      <section className="mx-auto grid max-w-7xl gap-12 px-6 py-20 md:px-12 lg:grid-cols-12">
        <div className="lg:col-span-4"><p className="eyebrow">Frequently asked</p></div>
        <div className="lg:col-span-8"><FaqList /></div>
      </section>
      <section className="border-t border-line bg-[#080808]">
        <div className="mx-auto max-w-7xl px-6 py-20 md:px-12">
          {POLICIES.map((p) => (
            <Reveal key={p.id}>
              <article id={p.id} data-testid={`policy-${p.id}`} className="grid scroll-mt-28 gap-4 border-b border-line py-10 md:grid-cols-12">
                <h2 className="font-display text-2xl text-white md:col-span-4">{p.title}</h2>
                <p className="leading-relaxed text-zinc-300 md:col-span-8">{p.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <section id="contact" className="mx-auto grid max-w-7xl scroll-mt-28 gap-12 px-6 py-24 md:px-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="eyebrow">Contact</p>
          <h2 className="font-display mt-5 text-4xl font-medium tracking-tight text-white">A real person answers.</h2>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-email-link" className="link-u mt-8 inline-flex items-center gap-3 text-lg text-white">
            <Mail size={18} /> {CONTACT_EMAIL}
          </a>
          <p className="mt-3 text-sm text-zinc-400">We usually reply within 1–2 business days.</p>
        </div>
        <div className="lg:col-span-6">
          <p className="mb-4 text-sm text-zinc-300">Get 10% off your first order.</p>
          <LeadCapture source="support" />
        </div>
      </section>
    </main>
  );
}
